var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSupportIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.32031 3.31162C3.36516 2.88324 3.52234 2.4725 3.7774 2.1172C4.03247 1.7619 4.37721 1.47347 4.7799 1.27844C5.18257 1.08342 5.63025 0.988078 6.08177 1.00119C6.53324 1.0143 6.974 1.13545 7.36347 1.35348C7.75294 1.57152 8.07862 1.87942 8.31051 2.24887C8.5424 2.6183 8.67306 3.0374 8.69045 3.46759C8.70783 3.89777 8.61143 4.32521 8.41005 4.71057C8.21247 5.08867 7.92007 5.41434 7.55895 5.65878",
    stroke: "black",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.6875 2.27344C4.10421 2.68346 4.6032 3.00942 5.15476 3.23192C5.70633 3.45443 6.29923 3.56893 6.89818 3.56862C7.48724 3.56917 8.07045 3.45862 8.61422 3.24347",
    stroke: "black",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.42153 5.39844C5.26943 5.39844 5.12072 5.44143 4.9942 5.522C4.8677 5.60255 4.76912 5.71706 4.71089 5.85103C4.65268 5.98494 4.63745 6.13235 4.66712 6.27457C4.6968 6.4168 4.77006 6.54744 4.87764 6.64993C4.98521 6.75247 5.12225 6.82231 5.27148 6.85061C5.4207 6.87886 5.57537 6.86435 5.71593 6.80887C5.85648 6.7534 5.97658 6.65941 6.06109 6.53884C6.14565 6.41832 6.19073 6.27653 6.19073 6.13157C6.19073 5.93714 6.10971 5.75064 5.96545 5.61315C5.8212 5.47567 5.62557 5.39844 5.42153 5.39844Z",
    stroke: "black",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.34375 4.14062V4.6675C2.34375 5.05637 2.50583 5.42931 2.79434 5.70429C3.08285 5.97926 3.47414 6.13375 3.88216 6.13375H4.612",
    stroke: "black",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9988 12.0011C10.9988 11.1295 10.7478 10.2746 10.273 9.52964C9.8002 8.78768 9.12361 8.1831 8.31641 7.78125",
    stroke: "black",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1 12C0.999897 11.1284 1.25079 10.2737 1.72533 9.52867C2.19751 8.78743 2.87308 8.18324 3.67905 7.78125",
    stroke: "black",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportIcon);
export default __webpack_public_path__ + "static/media/supportIcon.e45d50e375ad065523219a8875f09d0b.svg";
export { ForwardRef as ReactComponent };